import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useQuery, gql } from '@zenbusiness/application-commons-graphql';

import { mapBusinessEntityQuery } from '#client/utils/businessEntity';

import Amendments from './Amendments';

export const GET_AMENDMENTS_QUERY = gql`
  query AmendmentsQuery($businessEntityUuid: UUID!) {
    businessEntity(businessEntityUuid: $businessEntityUuid) {
      uuid
      type
    }
    accountInfo {
      accountUuid
      pricing(businessEntityUuid: $businessEntityUuid) {
        service
        amount
      }
    }
    orderTasksLegacy(businessEntityUuid: $businessEntityUuid) {
      orderTasksLegacy {
        createdDatetime
        orderTaskUuid
        orderTaskStatus
        orderTaskType
        orderTaskJurisdiction
      }
    }
  }
`;

const Renderer = () => {
  const { businessEntityUuid } = useBusinessEntity();

  const { loading = false, data = {} } = useQuery(
    GET_AMENDMENTS_QUERY,
    {
      variables: {
        businessEntityUuid
      }
    }
  );
  return <Amendments data={mapBusinessEntityQuery(data)} loading={loading} />;
};

export default Renderer;
